import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CardoList } from '@cotyorg/ccx-organism-cardo-list';
import CategoryBanner from '../../molecules/CategoryBanner';
import StandardLayout from '../../templates/StandardLayout';
import { showBV } from '../../utils';
import { CardSection1BreakpointConfig } from './cardo.config';
import BVProductRating from '../../molecules/BVProductRating';

const BestSellersComponent = ({ products, sectionHeadings, locale }) => (
  <StandardLayout>
    <CategoryBanner
      heading={R.path(['main', 'heading'])(sectionHeadings)}
      text={R.path(['main', 'introduction'])(sectionHeadings)}
    />

    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell">
          <CardoList
            breakpointConfig={CardSection1BreakpointConfig}
            data={products}
            initialNumberToShow={12}
            isTitleUnderlined={false}
            fixedHeight
            zoomOnHover
            showStarRating={showBV(locale)}
            extraClass="product-list"
            hideDescription
            imgRatingOffSrc="/ccx-files/assets/star-off.svg"
            imgRatingOnSrc={{
              fullStar: '/ccx-files/assets/star-on.svg',
              partialStar1: '/ccx-files/assets/partial-star-1.svg',
              partialStar2: '/ccx-files/assets/partial-star-2.svg',
              partialStar3: '/ccx-files/assets/partial-star-3.svg',
              partialStar4: '/ccx-files/assets/partial-star-4.svg',
              partialStar5: '/ccx-files/assets/partial-star-5.svg',
              partialStar6: '/ccx-files/assets/partial-star-6.svg',
              partialStar7: '/ccx-files/assets/partial-star-7.svg',
              partialStar8: '/ccx-files/assets/partial-star-8.svg',
              partialStar9: '/ccx-files/assets/partial-star-9.svg',
            }}
            showMoreIconSrc="/ccx-files/assets/plus-within-circle.svg"
            showMoreIconSize="medium"
            renderCustomRating={({ cardoIndex }) =>
              BVProductRating({
                bvid: R.path([cardoIndex, 'bvid'])(products),
              })
            }
          />
        </div>
      </div>
    </div>
  </StandardLayout>
);

BestSellersComponent.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
  sectionHeadings: PropTypes.objectOf(PropTypes.object),
  locale: PropTypes.string,
};

export default connect(({ content, locale }) => ({
  products: R.path(['cards', 'products'])(content),
  sectionHeadings: R.prop('sectionHeadings', content),
  viewMore: R.prop('viewMore', content),
  locale,
}))(BestSellersComponent);
